import type { FaireProductEntity } from "../../entity_types/product";

export const p_s5bne2bgsd: FaireProductEntity = {
  token: "p_s5bne2bgsd",
  type: "product",
  name: "peace + recovery | therapeutic roller",
  brandToken: "b_sj6dmdqsub",
  brandName: "Set Apart Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/7526eb2216d917fb1bf9e627143b1f18c86fe518119fc5e0b9ebb796e38ad7f9.jpeg",
  galleryImageUrls: [],
  priceDollars: 10.39,
  description:
    "one of our top sellers, these therapeutic 10ml rollers are the perfect addition to a daily work bag, diaper bag or center console + they make a great gift too! in a variety of blends, these rollers benefit the body + mind with their natural and organic ingredients.\n\nconsider this product for your retail shop, gift boxes for your clients, as a smaller item at your checkout station, or as a gift for your employees at holiday time!\n\ningredients:\nall organic: green mandarin oil, sweet marjoram oil, patchouli oil, roman chamomile oil, bourbon geranium oil, lavender oil, coconut oil carrier, dried lavender buds",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:55.242Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
